import { render, staticRenderFns } from "./ApothekeDetailDialog.vue?vue&type=template&id=c719b2d4&"
import script from "./ApothekeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ApothekeDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports